import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteCustomPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.deleteCustomPerk,
  {
    mutationKey: ['deleteCustomPerk'],
  },
)
